import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/components/stock/inventory-listing.js")